import { RootState } from '../store';
import { ActionTree, GetterTree, Module, MutationTree } from 'vuex';
import { Notification } from "@/domain/notification";
import { Api } from "@/api/api";

export interface NotificationState {
    unhandledNotifications: Notification[];
    newNotifications: Notification[];
    selectedNotification: Notification | undefined;
}

export const state: NotificationState = {
    unhandledNotifications: [],
    newNotifications: [],
    selectedNotification: undefined
};

export const getters: GetterTree<NotificationState, RootState> = {
    getAllUnhandledNotifications: state => state.unhandledNotifications,
    getnewNotifications: state => state.newNotifications,
    getSelectedNotification: state => state.selectedNotification
};

export const mutations: MutationTree<NotificationState> = {
    ADD_ALL_UNHANDLED_NOTIFICATIONS: (state, notifications: Notification[]) => {
        state.unhandledNotifications = notifications;
    },
    ADD_RECEIVED_NOTIFICATION: (state, notification: Notification) => {
        state.newNotifications.push(notification); // push to new notifications so a pop up will be shown
        state.unhandledNotifications.push(notification); // push to new unhandledNotifications to update the overview table
    },
    CLEAR_NEW_NOTIFICATIONS: (state) => {
        state.newNotifications = []; // clear newNotifications when the user clicks on the new notification popup
    },
    SET_SELECTED_NOTIFICATION: (state, notification: Notification) => {
        state.selectedNotification = notification;
    },
};

export const actions: ActionTree<NotificationState, RootState> = {
    FETCH_ALL_UNHANDLED_NOTIFICATIONS({ commit }) {
        return Api.Notification.fetchAllUnhandledNotifications()
            .then(response => commit('ADD_ALL_UNHANDLED_NOTIFICATIONS', response.notifications));
    },
    RECEIVED_NEW_NOTIFICATION({ commit }, notification) {
        const notificationObj: Notification = JSON.parse(notification);
        commit('ADD_RECEIVED_NOTIFICATION', notificationObj);
    },
    CLEAR_NEW_NOTIFICATIONS({ commit }) {
        commit('CLEAR_NEW_NOTIFICATIONS');
    },
    SET_SELECTED_NOTIFICATION({ commit }, notification: Notification) {
        commit('SET_SELECTED_NOTIFICATION', notification);
    },
    SET_NOTIFICATION_HANDLED({}, notificationId: number) {
        return Api.Notification.setNotificationHandled(notificationId);
    }
};

export const NotificationStore: Module<NotificationState, RootState> = {
    state,
    getters,
    mutations,
    actions
};
